import { computed, ref } from 'vue'
import type { RoleKey } from '@/types/business'
import { menuGroups } from '@/config/menu'

export const roleOptions: { value: RoleKey; label: string; scope: string }[] = [
  { value:'region', label:'自治区监管', scope:'全区演示数据' },
  { value:'county', label:'市县管理', scope:'示例市县数据' },
  { value:'institution', label:'培训机构', scope:'示例机构数据' },
  { value:'expert', label:'专家', scope:'本人任务演示数据' },
  { value:'student', label:'学员', scope:'本人服务演示数据' }
]

const saved = typeof localStorage === 'undefined' ? null : localStorage.getItem('demo-role') as RoleKey | null
const activeRole = ref<RoleKey>(saved && roleOptions.some(r => r.value === saved) ? saved : 'region')

export function useDemoRole() {
  const setRole = (role: RoleKey) => {
    activeRole.value = role
    if (typeof localStorage !== 'undefined') localStorage.setItem('demo-role', role)
  }
  const role = computed(() => roleOptions.find(item => item.value === activeRole.value)!)
  const menus = computed(() => menuGroups.filter(item => item.roles.includes(activeRole.value)))
  return { activeRole, role, menus, setRole }
}
